<template>
  <svg viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 4.625L9.375 0.25L0.625 0.25L5 4.625Z" />
  </svg>
</template>
